/**
 * PC Collection Filters
 * Native Shopify tag-based filtering for Paula's Choice
 * AJAX-based: no page refresh on filter or sort change
 */
(function() {
  'use strict';

  var sidebar = document.querySelector('.pc-filter-sidebar');
  if (!sidebar) return;

  var collectionHandle = sidebar.dataset.collectionHandle;
  var baseUrl = '/collections/' + collectionHandle;
  var isLoading = false;

  // Returns scroll offset accounting for sticky header (if enabled and would be active).
  // When sticky becomes position:fixed it's removed from flow, shifting content up by headerH.
  // If sticky will activate during the upcoming scroll, deduct extra to compensate.
  function getStickyOffset(targetY) {
    var h = document.getElementById('SiteHeader');
    if (!h || h.dataset.stickyEnabled !== 'true') return 20;
    if (targetY <= 50) return 20;
    var headerH = h.offsetHeight;
    var willShift = !h.classList.contains('scrolled');
    return willShift ? (2 * headerH + 10) : (headerH + 10);
  }

  // ============================================
  // Loading State
  // ============================================
  function showLoading() {
    isLoading = true;

    // Disable all filter checkboxes
    var checkboxes = document.querySelectorAll('.pc-filter-sidebar input[type="checkbox"]');
    checkboxes.forEach(function(cb) { cb.disabled = true; });

    // Disable sort
    var sort = document.getElementById('PcSortBy');
    if (sort) sort.disabled = true;

    // Fade product grid + show loading indicator
    var grid = document.querySelector('.pc-product-grid');
    if (grid) {
      grid.classList.add('pc-grid-loading');
    }
    if (grid && !grid.querySelector('.pc-loading-overlay')) {
      var overlay = document.createElement('div');
      overlay.className = 'pc-loading-overlay';
      overlay.innerHTML = '<div class="pc-loading-spinner"></div><span class="pc-loading-text">Filtering products...</span>';
      grid.appendChild(overlay);
    }

    // Also disable drawer checkboxes if open
    var drawerBody = document.getElementById('FilterDrawerBody');
    if (drawerBody) {
      var drawerCbs = drawerBody.querySelectorAll('input[type="checkbox"]');
      drawerCbs.forEach(function(cb) { cb.disabled = true; });
    }
  }

  function hideLoading() {
    isLoading = false;

    // Re-enable checkboxes
    var checkboxes = document.querySelectorAll('.pc-filter-sidebar input[type="checkbox"]');
    checkboxes.forEach(function(cb) { cb.disabled = false; });

    // Re-enable sort
    var sort = document.getElementById('PcSortBy');
    if (sort) sort.disabled = false;

    // Remove loading state
    var grid = document.querySelector('.pc-product-grid');
    if (grid) {
      grid.classList.remove('pc-grid-loading');
    }
    var grid2 = document.querySelector('.pc-product-grid');
    if (grid2) {
      var overlay = grid2.querySelector('.pc-loading-overlay');
      if (overlay) overlay.remove();
    }
  }

  // ============================================
  // Build filter URL from checked boxes
  // ============================================
  function buildFilterUrl(container) {
    // Get tags from sidebar checkboxes
    var checked = container.querySelectorAll('input[type="checkbox"]:checked');
    var tags = [];
    var sidebarGroups = {};
    checked.forEach(function(cb) {
      tags.push(cb.value);
      if (cb.dataset.group) sidebarGroups[cb.dataset.group] = true;
    });

    // Preserve tags from thumbnail groups (not in sidebar) by reading URL
    var pathTags = window.location.pathname.replace(baseUrl, '').replace(/^\//, '');
    if (pathTags) {
      pathTags.split('+').filter(Boolean).forEach(function(t) {
        // Check if this tag belongs to a sidebar group — if not, it's a thumbnail tag, keep it
        var belongsToSidebar = false;
        var allSidebarCbs = container.querySelectorAll('input[type="checkbox"]');
        allSidebarCbs.forEach(function(cb) {
          if (cb.value === t) belongsToSidebar = true;
        });
        if (!belongsToSidebar && tags.indexOf(t) === -1) {
          tags.push(t);
        }
      });
    }

    var tagPath = tags.length > 0 ? '/' + tags.join('+') : '';
    var sortParam = getQueryParam('sort_by');
    var newUrl = baseUrl + tagPath;
    if (sortParam) newUrl += '?sort_by=' + sortParam;
    return newUrl;
  }

  // ============================================
  // AJAX Content Loading
  // ============================================
  function loadContent(url, pushState) {
    if (isLoading) return;
    showLoading();

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Replace product grid + count + pagination
        var newAjaxContent = doc.getElementById('CollectionAjaxContent');
        var currentAjaxContent = document.getElementById('CollectionAjaxContent');
        if (newAjaxContent && currentAjaxContent) {
          currentAjaxContent.innerHTML = newAjaxContent.innerHTML;
        }

        // Re-bind sidebar (sidebar was replaced)
        sidebar = document.querySelector('.pc-filter-sidebar');
        if (sidebar) {
          bindSidebarCheckboxes();
        }

        // Re-bind sort
        bindSort();

        // Re-init lazy loading if theme has it
        if (typeof lazySizes !== 'undefined') {
          lazySizes.init();
        }

        // Re-init narrow sliders
        waitForSwiper(initNarrowSliders);

        // Update drawer content if open
        var drawer = document.getElementById('FilterDrawer');
        var drawerBody = document.getElementById('FilterDrawerBody');
        if (drawer && drawer.classList.contains('is-open') && drawerBody) {
          var newSidebar = document.querySelector('.pc-filter-sidebar__inner');
          if (newSidebar) {
            drawerBody.innerHTML = newSidebar.innerHTML;
            bindDrawerCheckboxes();
          }
        }

        // Update URL
        if (pushState !== false) {
          history.pushState({ pcFilter: true }, '', url);
        }

        // Scroll to collection title area
        var collectionHeader = document.querySelector('.collection-header') || document.querySelector('.collection-content');
        if (collectionHeader) {
          var targetY = collectionHeader.getBoundingClientRect().top + window.scrollY;
          var offset = targetY - getStickyOffset(targetY);
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
      })
      .catch(function(err) {
        console.error('Filter load error:', err);
        window.location.href = url;
      })
      .finally(function() {
        hideLoading();
      });
  }

  // ============================================
  // Sidebar Checkbox Events
  // ============================================
  function bindSidebarCheckboxes() {
    if (!sidebar) return;
    sidebar.addEventListener('change', function(e) {
      if (e.target.type !== 'checkbox') return;
      var url = buildFilterUrl(sidebar);
      loadContent(url);
    });
  }

  bindSidebarCheckboxes();

  // ============================================
  // Show More / Show Less Toggle
  // ============================================
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-show-more]');
    if (!btn) return;
    var group = btn.closest('.pc-filter-group');
    if (!group) return;
    var isExpanded = group.classList.toggle('pc-filter-group--expanded');
    var moreText = btn.querySelector('.pc-filter-show-more__more');
    var lessText = btn.querySelector('.pc-filter-show-more__less');
    if (moreText) moreText.style.display = isExpanded ? 'none' : '';
    if (lessText) lessText.style.display = isExpanded ? '' : 'none';
  });

  // ============================================
  // AJAX Links (Clear All, Clear Group, Remove Tag, Pagination)
  // ============================================
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-filter-clear-all], [data-filter-clear-group], [data-filter-remove], .pagination a');
    if (link && link.href) {
      e.preventDefault();
      loadContent(link.href);
    }
  });

  // ============================================
  // Sort Dropdown
  // ============================================
  function bindSort() {
    var sortSelect = document.getElementById('PcSortBy');
    if (!sortSelect) return;
    // Remove old listeners by cloning
    var newSelect = sortSelect.cloneNode(true);
    sortSelect.parentNode.replaceChild(newSelect, sortSelect);
    newSelect.addEventListener('change', function() {
      var sortValue = this.value;

      // Top Rated = client-side sort by data-rating attribute
      if (sortValue === 'top-rated') {
        sortByRating();
        history.pushState({ pcFilter: true }, '', window.location.pathname + window.location.search);
        return;
      }

      var currentPath = window.location.pathname;
      var newUrl = currentPath + '?sort_by=' + sortValue;
      loadContent(newUrl);
    });
  }

  function sortByRating() {
    var grid = document.querySelector('.pc-product-grid');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll('.grid-product'));
    items.sort(function(a, b) {
      var ratingA = parseFloat(a.dataset.rating) || 0;
      var ratingB = parseFloat(b.dataset.rating) || 0;
      if (ratingB !== ratingA) return ratingB - ratingA;
      var countA = parseInt(a.dataset.reviewCount) || 0;
      var countB = parseInt(b.dataset.reviewCount) || 0;
      return countB - countA;
    });

    items.forEach(function(item) {
      grid.appendChild(item);
    });
  }

  bindSort();

  // ============================================
  // Browser Back/Forward
  // ============================================
  window.addEventListener('popstate', function(e) {
    if (e.state && e.state.pcFilter) {
      loadContent(window.location.href, false);
    } else {
      loadContent(window.location.href, false);
    }
  });

  // ============================================
  // Mobile Filter Drawer
  // ============================================
  var drawer = document.getElementById('FilterDrawer');
  var drawerBody = document.getElementById('FilterDrawerBody');
  var drawerClose = drawer ? drawer.querySelector('.pc-filter-drawer__close') : null;
  var drawerOverlay = drawer ? drawer.querySelector('.pc-filter-drawer__overlay') : null;
  var drawerApply = drawer ? drawer.querySelector('.pc-filter-drawer__apply') : null;

  document.addEventListener('click', function(e) {
    if (e.target.closest('#MobileFilterToggle')) {
      openDrawer();
    }
  });

  function openDrawer() {
    if (!drawer || !drawerBody) return;
    var sidebarContent = document.querySelector('.pc-filter-sidebar__inner');
    if (sidebarContent) {
      drawerBody.innerHTML = sidebarContent.innerHTML;
      bindDrawerCheckboxes();
    }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function bindDrawerCheckboxes() {
    if (!drawerBody) return;
    drawerBody.addEventListener('change', function(e) {
      if (e.target.type !== 'checkbox') return;
      var url = buildFilterUrl(drawerBody);
      loadContent(url);
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function showProducts() {
    closeDrawer();
  }

  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
  if (drawerApply) drawerApply.addEventListener('click', showProducts);

  // ============================================
  // Narrow by Filter - Thumbnail Slider
  // ============================================
  var narrowScrollPositions = {};

  function saveNarrowScrollPositions() {
    document.querySelectorAll('.pc-narrow__swiper .swiper-wrapper').forEach(function(wrapper) {
      var id = wrapper.closest('.pc-narrow').id;
      if (id) narrowScrollPositions[id] = wrapper.style.transform || '';
    });
  }

  function initNarrowSliders() {
    var narrowEls = document.querySelectorAll('.pc-narrow');
    if (!narrowEls.length || typeof Swiper === 'undefined') return;

    narrowEls.forEach(function(el) {
      var sliderId = el.id;
      var swiperEl = document.getElementById(sliderId + '-swiper');
      var controls = document.getElementById(sliderId + '-controls');
      var progressBar = document.getElementById(sliderId + '-progress');
      var prevBtn = document.getElementById(sliderId + '-prev');
      var nextBtn = document.getElementById(sliderId + '-next');
      if (!swiperEl) return;

      // Find active slide index to restore position
      var initialSlide = 0;
      var slides = swiperEl.querySelectorAll('.pc-narrow__slide');
      slides.forEach(function(slide, i) {
        if (slide.querySelector('.pc-narrow__card--active')) initialSlide = Math.max(0, i - 1);
      });

      var swiper = new Swiper(swiperEl, {
        initialSlide: initialSlide,
        slidesPerView: 'auto',
        spaceBetween: 12,
        freeMode: true,
        watchSlidesProgress: true,
        on: {
          init: function() { toggleControls(this); updateProgress(this); },
          resize: function() { toggleControls(this); },
          progress: function() { updateProgress(this); }
        }
      });

      function toggleControls(sw) {
        if (controls) controls.style.display = sw.virtualSize > sw.size ? 'flex' : 'none';
      }
      function updateProgress(sw) {
        var p = Math.max(0, Math.min(1, sw.progress));
        if (progressBar) progressBar.style.width = (p * 100) + '%';
        if (prevBtn) prevBtn.disabled = sw.isBeginning;
        if (nextBtn) nextBtn.disabled = sw.isEnd;
      }
      if (prevBtn) prevBtn.addEventListener('click', function() { swiper.slidePrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { swiper.slideNext(); });
    });
  }

  // Narrow card click — handles single, multi, filtered modes
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.pc-narrow__card');
    if (!card || !card.href) return;
    e.preventDefault();

    var clickedTag = card.dataset.narrowTag;
    var mode = card.dataset.narrowMode;
    var isActive = card.classList.contains('pc-narrow__card--active');

    // Get current sidebar checkbox tags (other groups)
    var sidebarChecked = sidebar ? sidebar.querySelectorAll('input[type="checkbox"]:checked') : [];
    var sidebarTags = [];
    sidebarChecked.forEach(function(cb) { sidebarTags.push(cb.value); });

    // Get current thumbnail tags from URL (tags not in sidebar)
    var pathTags = window.location.pathname.replace(baseUrl, '').replace(/^\//, '');
    var urlTags = pathTags ? pathTags.split('+').filter(Boolean) : [];
    var thumbnailTags = [];
    urlTags.forEach(function(t) {
      var inSidebar = false;
      if (sidebar) {
        sidebar.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
          if (cb.value === t) inSidebar = true;
        });
      }
      if (!inSidebar) thumbnailTags.push(t);
    });

    var tags = sidebarTags.slice();

    if (mode === 'thumbnail_single') {
      // Single select: clear ALL filters, only keep the clicked tag
      tags = [];
      if (!isActive && clickedTag) {
        tags.push(clickedTag);
      }
    } else {
      // Multi / Filtered: toggle clicked tag, keep other thumbnail tags
      thumbnailTags.forEach(function(t) {
        if (t !== clickedTag) tags.push(t);
      });
      if (!isActive && clickedTag) {
        tags.push(clickedTag);
      }
    }

    var tagPath = tags.length > 0 ? '/' + tags.join('+') : '';
    var sortParam = getQueryParam('sort_by');
    var newUrl = baseUrl + tagPath;
    if (sortParam) newUrl += '?sort_by=' + sortParam;

    loadContent(newUrl);
  });

  // Init sliders on load + after AJAX
  function waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') { callback(); }
    else {
      var check = setInterval(function() {
        if (typeof Swiper !== 'undefined') { clearInterval(check); callback(); }
      }, 100);
    }
  }
  waitForSwiper(initNarrowSliders);

  // ============================================
  // Utility
  // ============================================
  function getQueryParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  }
})();
